import React from 'react';
import { Link, withRouter } from "react-router-dom"
import {Input,Form,FormGroup,Label} from "reactstrap";
const Columns = ( items,setItems) => {
	
	const duplicate= (row) => {
		duplicateBranch(row).then(response => {
			if (response.status) {
				const newItem = response.branch;
				let array = [...items, newItem];
				array.sort((a, b) => {
					return a.id - b.id;
				});
				setItems(array);
			}
		})
	}

	let columns = [
	{
		id: 'no',
		name: 'Id',
		selector: row => row.no,
		sortable: true,
		wrap: true,
	},
	{
		id: 'user_id',
		name: 'Analista',
		selector: row => row.user_name,
		sortable: true,
		wrap: true,
	},
	{
		id: 'date_time',
		name: 'Fecha',
		selector: row => row.date_time,
		sortable: true,
		wrap: true,
	},
	{
		id: 'unit_name',
		name: 'Unidad',
		selector: row => row.unit_name,
		sortable: true,
		wrap: true,
	},
	{
		id: 'operator_name',
		name: 'Operador',
		selector: row => row.operator_name,
		sortable: true,
		wrap: true,
	},
	{
		id: 'destination',
		name: 'Destino',
		selector: row => row.destination,
		sortable: true,
		wrap: true,
	},
	{
		id: 'actions',
		name: 'Acciones',
		width:'15%',
		button: true,
		cell: row => (
			<div className="d-flex justify-content-between">
				<div className="pe-1">
					<button className="btn btn-primary btn-sm" title='Detalle Salida' onClick={() => setModalDetail({...modalDetail,show:true,id:row.id,title:`Salida ${row.id} - ${row.destination}`})}><i className="fa fa-eye"></i></button>
				</div>
				<div className="pe-1">
					<button className="btn btn-primary btn-sm" title='Editar Salida' onClick={() => addUpd(row)}><i className="fas fa-edit"></i></button>
				</div>
				<div className="pe-1">
					<button className="btn btn-primary btn-sm" title='Regreso de salidas' onClick={() => setModalReturn({...modalReturn,show:true,id:row.id,timeBase:row.timeBase})}><i className="fa fa-cog"></i></button>
				</div>
				<div className="pe-1">
					<button className="btn btn-danger btn-sm" title='Eliminar Salida' onClick={() => destroy(row.id)}><i className="fas fa-trash"></i></button>
				</div>
			</div>
			),
		}

		];
		return columns;
	}

	export default Columns;

//vaneton beicli